import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";

import importAll from "../../../lib/utils/image";
import CloudinaryImage from "../../Common/CloudinaryImage";

const Gallery = () => {
  const theme = useTheme();
  const allImages = importAll(
    require.context(
      "../../../public/static/images/about/gallery",
      false,
      /\.(png|jpe?g|svg|webp)$/
    )
  );

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [
    {
      fileName: "gallery_1.jpg",
      rows: 2,
      cols: 1,
    },
    {
      fileName: "gallery_2.jpg",
      rows: 1,
      cols: 2,
    },
    {
      fileName: "gallery_3.jpg",
      rows: 1,
      cols: 1,
    },
    {
      fileName: "gallery_5.jpg",
      rows: 1,
      cols: 1,
    },
    {
      fileName: "gallery_4.jpg",
      rows: 1,
      cols: 2,
    },
  ];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length - 1);

  return (
    <Box>
      <ImageList
        variant="quilted"
        cols={4}
        rowHeight={isMd ? 300 : 220}
        gap={isMd ? 16 : 8}
      >
        {photosToShow.map((item, i) => (
          <ImageListItem
            key={i}
            cols={isMd ? item.cols || 1 : 2}
            rows={isMd ? item.rows || 1 : 1}
          >
            <CloudinaryImage
              src={allImages[item.fileName]}
              alt={`Image Gallery ${i + 1}`}
              layout="fill"
              objectFit="cover"
              style={{
                borderRadius: 4,
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
};

export default Gallery;
